import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColorSwatch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconColorSwatch"><Path fillRule="evenodd" clipRule="evenodd" d="M13 2H2V16.5C2 19.5376 4.46243 22 7.5 22C8.53234 22 9.49824 21.7156 10.3236 21.2208L22.8077 14.0131L19.0474 7.5L19.5135 6.69264L13 2.93209V2ZM20.7587 13.4641L13.0266 17.9282L18.1813 9L20.7587 13.4641ZM13 14.9743L17.4644 7.24168L13 4.66414V14.9743ZM7.5 18.25C8.4665 18.25 9.25 17.4665 9.25 16.5C9.25 15.5335 8.4665 14.75 7.5 14.75C6.5335 14.75 5.75 15.5335 5.75 16.5C5.75 17.4665 6.5335 18.25 7.5 18.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColorSwatch;
